import { $Q, $Qll } from 'graditify-utils'

/**
* Estructure the money with currency value
* @param {string} str string with the price type number.
* @return money number with europe money code ej. input 3.45 return €3,45
*/
export function concatRegexp (initial, exp) {
  const formating = Number(exp)
    .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
    .replace(' €', '')

  return initial.replace(/\d+([.\d+.\d,]+\d{2})?/g, formating)
}

function cents (str, fixed) {
  const number = Number(str) / 100
  if (fixed) return number.toFixed(2)
  return number
}

/**
 *
 * we control the price range filter in order to avoid that the minimum
 * value is greater than the highest value and that the highest
 * value is not less than the lowest value
 *
 */
class FilterElement extends HTMLElement {
  constructor () {
    super()
    this.minValue = $Q('.min-value-js', this)
    this.maxValue = $Q('.max-value-js', this)
    this.progress = $Q('.slider-filter .pro', this)

    this.priceMin = $Q('.price-in input.in-min', this)
    this.priceMax = $Q('.price-in input.in-max', this)
    this.defaultMax = Number(this.priceMax.max)
    this.priceGap = 1000

    this.rangeIn = $Qll('.range-in input', this)
  }

  /* static get observedAttributes () {
    return ['']
  }

  attributeChangedCallback (name, oldVal, newVal) {
  }
 */
  connectedCallback () {
    this.initialize()
    this.onChangeInput()
  }

  initialize () {
    if (this.priceMin.value) {
      this.progress.style.left = `${(this.priceMin.value / this.rangeIn[0].max) * 10000}%`
      this.progress.style.right = `${100 - (this.priceMax.value / this.rangeIn[1].max) * 10000}%`
    }
  }

  onChangeInput () {
    this.rangeIn.forEach((input) => {
      input.addEventListener('input', (e) => {
        const minVal = Number(this.rangeIn[0].value)
        const maxVal = Number(this.rangeIn[1].value)

        if (maxVal - minVal <= this.priceGap) {
          this.reset(e.target.className)
        } else {
          this.max(maxVal)
          this.min(minVal)
        }
      })
    })
  }

  max (value) {
    const maxIn = cents(value, true)
    this.priceMax.value = maxIn
    this.maxValue.textContent = concatRegexp('0,00', maxIn)
    this.progress.style.right = `${100 - (value / this.defaultMax) * 100}%`
    this.priceMax.dispatchEvent(new Event('change'))
  }

  min (value) {
    const minIn = cents(value, true)
    this.priceMin.value = minIn
    this.minValue.textContent = concatRegexp('0,00', minIn)
    this.progress.style.left = `${(value / this.defaultMax) * 100}%`
    this.priceMin.dispatchEvent(new Event('change'))
  }

  reset (type) {
    if (type === 'range-min') {
      this.min(0)
      this.rangeIn[0].value = 0
    } else {
      this.max(this.defaultMax)
      this.rangeIn[1].value = this.defaultMax
    }
  }
}

(function formatValues () {
  $Qll('.price-in input').forEach(
    (item) => {
      item.value = cents(item.value, true)
    }
  )
}())

customElements.define('filter-element', FilterElement)
